import type { PropsWithChildren } from 'react';

import type { IncrementProductRefillCardProps } from './IncrementProductRefillCard';
import IncrementProductRefillCard from './IncrementProductRefillCard';
import ProductCategoryAccordion from './ProductCategoryAccordion';

export interface ProductSectionProps {
  products: IncrementProductRefillCardProps[];
  label: string;
  stickyHeader?: boolean;
  startCollapsed?: boolean;
  /** Overrides the header count when children render cards beyond `products`. */
  count?: number;
}

export function ProductList({ products }: Pick<ProductSectionProps, 'products'>) {
  return products.map((product) => {
    return <IncrementProductRefillCard key={product.id} {...product} />;
  });
}

export function ProductSection({
  products,
  label,
  startCollapsed,
  stickyHeader,
  count,
  children,
}: PropsWithChildren<ProductSectionProps>) {
  return (
    <ProductCategoryAccordion
      label={label}
      count={count ?? products.length}
      startCollapsed={startCollapsed}
      stickyHeader={stickyHeader}
    >
      <ProductList products={products} />
      {children}
    </ProductCategoryAccordion>
  );
}
